export class ConfigDto {
    solutionLookup = null;
}

export class ConfigState {
    loading = false;
    record = new ConfigDto();
    error = null;
}
